<template>
  <div v-if="portalProfiles != null" id="show-portal-profile-card">
    <v-card class="mt-3">
      <v-card-title>
        Modèles de portail prédéfinis
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          icon
          @click.stop="
            [(currentPortalProfileId = null), (portalProfileDialog = true)]
          "
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-if="portalProfiles.length > 0"
          :headers="headers"
          :items="portalProfiles"
          :items-per-page="10"
          dense
        >
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  :to="{ name: 'profils-portails', params: { id: item.id } }"
                  ><v-icon>mdi-eye-plus</v-icon></v-btn
                ></template
              >
              <span>Voir le modèle de portail</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  @click.stop="
                    [
                      (currentPortalProfileId = item.id),
                      (portalProfileDialog = true),
                    ]
                  "
                  ><v-icon>mdi-square-edit-outline</v-icon></v-btn
                ></template
              >
              <span>Editer le modèle de portail</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  @click="deletePortalProfile(item, partner.id)"
                  ><v-icon>mdi-delete</v-icon></v-btn
                ></template
              >
              <span>Supprimer le modèle de portail</span>
            </v-tooltip>
          </template>

          <template v-slot:item.freeCardModel="{ item }">
            {{ currentFreeCardModel(item.portalOptions.freeCardModel) }}
          </template>
          <template v-slot:item.basicProfile="{ item }">
            {{ currentBasicProfile(item.portalOptions.basicProfile) }}
          </template>
          <template v-slot:item.fullProfile="{ item }">
            {{ currentFullProfile(item.portalOptions.fullProfile) }}
          </template>
        </v-data-table>
        <div v-else>Pas de modèle de portail prédéfini pour ce partenaire.</div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="portalProfileDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Edition du Modèle de portail</span>
        </v-card-title>
        <v-card-text>
          <v-container v-if="portalProfileForm != null">
            <v-form ref="portalProfileFormRef">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    :rules="nameRules"
                    v-model="portalProfileForm.name"
                    label="Nom"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    :rules="descriptionRules"
                    v-model="portalProfileForm.description"
                    label="Description"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    v-model="portalProfileForm.isSandboxModeActive"
                    label="Mode sandbox?"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :rules="vatRules"
                    v-model="portalProfileForm.portalOptions.vat"
                    label="TVA"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="portalProfileForm.portalOptions.basicProfile"
                    label="Basic Profile"
                    required
                    :items="profiles"
                    item-text="label"
                    item-value="id"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="portalProfileForm.portalOptions.fullProfile"
                    label="Full Profile"
                    required
                    :items="profiles"
                    item-text="label"
                    item-value="id"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="portalProfileForm.portalOptions.freeCardModel"
                    label="Free Card Model"
                    required
                    :items="cardModels"
                    item-text="description"
                    item-value="id"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="portalProfileDialog = false"
            >Fermer</v-btn
          >
          <v-btn
            v-if="currentPortalProfileId != null"
            color="blue darken-1"
            text
            @click="updatePortalProfile(currentPortalProfileId, partner.id)"
            >Modifier</v-btn
          >
          <v-btn
            v-else
            color="blue darken-1"
            text
            @click="createPortalProfile(partner.id)"
            >Créer</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { usePortalProfile } from "../../composables/portal-profile";
import { onMounted, ref, watch, toRefs } from "@vue/composition-api";
import { useCardModel } from "../../composables/card-model";
import { useProfile } from "../../composables/profile";

export default {
  props: {
    partner: Object,
  },

  setup(props) {
    const {
      portalProfileData,
      listPortalProfileV5,
      portalProfiles,
      portalProfileForm,
      showPortalProfile,
      createPortalProfile,
      updatePortalProfile,
      deletePortalProfile,
    } = usePortalProfile();
    const { cardModels, listCardModels } = useCardModel();
    const { profiles, listProfiles } = useProfile();

    const currentPortalProfileId = ref(null);
    onMounted(() => {
      listPortalProfileV5(props.partner.id);
      const freeCardOrigin = 3;
      listCardModels(props.partner.id, freeCardOrigin);
      listProfiles(props.partner.id);
    });

    watch(
      () => portalProfileData.portalProfileDialog,
      function (newValue, oldValue) {
        if (oldValue != null && newValue == true) {
          portalProfileForm.value = null;
          if (currentPortalProfileId.value != null) {
            showPortalProfile(currentPortalProfileId.value);
          } else {
            portalProfileForm.value = {
              portalOptions: {},
              portalConfiguration: {},
            };
          }
        }
      }
    );

    const currentBasicProfile = (basicProfileId) => {
      let basicProfile = profiles.value.find(
        (element) => element.id == basicProfileId
      );

      if (basicProfile != null) {
        return basicProfile.description;
      }
    };

    const currentFullProfile = (fullProfileId) => {
      let fullProfile = profiles.value.find(
        (element) => element.id == fullProfileId
      );

      if (fullProfile != null) {
        return fullProfile.description;
      }
    };

    const currentFreeCardModel = (freeCardModelId) => {
      let freeCardModel = cardModels.value.find(
        (element) => element.id == freeCardModelId
      );
      if (freeCardModel != null) {
        return freeCardModel.description;
      }
    };

    return {
      ...toRefs(portalProfileData),
      portalProfileForm,
      profiles,
      portalProfiles,
      headers: [
        { text: "Description", value: "name" },
        { text: "BASIC Profile", value: "basicProfile" },
        { text: "FULL Profile", value: "fullProfile" },
        { text: "Modèle", value: "freeCardModel" },

        { text: "Action", value: "actions" },
      ],
      currentPortalProfileId,
      createPortalProfile,
      updatePortalProfile,
      cardModels,
      deletePortalProfile,
      currentBasicProfile,
      currentFullProfile,
      currentFreeCardModel,
    };
  },
};
</script>
